import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds } from 'src/constants/personalizationIds'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/logos/logo-fubotv-uefa-euro-qualifiers.png?w=300&ch=width&auto=format,compress"
    logoHeight="90px"
    video={videos.uefa_euro_qualifiers.videoUrl}
    title="Watch UEFA European Qualifiers live"
    subtitle="Get complete coverage only on Fubo"
    networkSet="soccer"
    customNetworks={['fsn']}
    sportId={sportIds.Soccer}
  />
)
